export const ROUTES = {
  HOME: '/',
  CALCULATOR: '/#calculator',
  CATALOG: '/catalog',
  FIN_SERVICES: '/fin-services',
  ABOUT: '/about',
  BLOG: '/blog',
  CONTACTS: '/contacts',
} as const
